import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import PageHome from '../componentes/plantilla/PageHome';
import EditarCotizacion from '../paginas/clientes/cotizaciones/EditarCotizacion';
import HomeCotizaciones from '../paginas/clientes/cotizaciones/HomeCotizaciones';
import HomeClientes from "../paginas/clientes/HomeClientes";
import InicioCliente from '../paginas/clientes/inicio/InicioClientes';
import ProductoDetalle from '../paginas/clientes/inicio/ProductoDetalle';
import ProductosCatalogo from "../paginas/clientes/inicio/ProductosCatalogo";
import EditarPedidos from "../paginas/clientes/pedidos/EditarPedidos";
import HomePedidos from "../paginas/clientes/pedidos/HomePedidos";
import HomeAccesos from '../paginas/empleados/accesos/HomeAccesos';
import HomeBuscarEmpleados from '../paginas/empleados/buscar/HomeBuscarEmpleados';
import HomeBuscarApertura from '../paginas/empleados/caja/buscarApertura/HomBuscarApertura';
import HomeBuscarCierre from '../paginas/empleados/caja/buscarCierre/HomeBuscarCierre';
import HomeApertura from '../paginas/empleados/caja/HomeApertura';
import HomeCierre from '../paginas/empleados/caja/HomeCierre';
import HomeIngresoEgreso from '../paginas/empleados/caja/ingresosEgresos/HomeIngresoEgreso';
import HomePagos from '../paginas/empleados/caja/pagos/HomePagos';
import HomeCargos from "../paginas/empleados/cargos/HomeCargos";
import HomeBuscarClientes from '../paginas/empleados/clientes/buscar/HomeBuscarClientes';
import HomeClientesEmpleados from '../paginas/empleados/clientes/editar/HomeClientes';
import NuevoCliente from '../paginas/empleados/clientes/NuevoCliente';
import NuevoClienteAuto from '../paginas/empleados/clientes/NuevoClienteAuto';
import HomeEditarCompras from '../paginas/empleados/compras/anular/HomeEditarCompras';
import HomeCreditoCompra from '../paginas/empleados/compras/credito/HomeCredito';
import HomeCompras from '../paginas/empleados/compras/HomeCompras';
import EditarCotizacionEmpleado from '../paginas/empleados/cotizaciones/EditarCotizacion';
import HomeCotizacionesEmpleados from '../paginas/empleados/cotizaciones/HomeCotizaciones';
import EditarEmpleados from "../paginas/empleados/EditarEmpleados";
import HomeEmpleados from '../paginas/empleados/HomeEmpleado';
import InicioEmpleados from '../paginas/empleados/inicio/InicioEmpleados';
import HomeAnularInventarios from '../paginas/empleados/inventarios/anular/HomeAnularInventarios';
import HomeInventarios from '../paginas/empleados/inventarios/HomeInventarios';
import HomeInventarioTipo from '../paginas/empleados/inventarios/tipos/HomeInvetarioTpos';
import EditSelectLote from '../paginas/empleados/lotes/editar/HomeEditarLoteInventario';
import HomeSelectLotes from '../paginas/empleados/lotes/editar/HomeSelectLote';
import EditarLotes from '../paginas/empleados/lotes/EditarLotes';
import HomeEditarLotes from '../paginas/empleados/lotes/HomeEditarLote';
import NuevoEmpleado from "../paginas/empleados/NuevoEmpleado";
import HomeBuscarPedidos from '../paginas/empleados/pedidos/buscar/HomeBuscarPedidos';
import EditarPedidosEmpleado from "../paginas/empleados/pedidos/EditarPedidos";
import HomePedidosEmpleado from "../paginas/empleados/pedidos/HomePedidos";
import HomeBuscarProductos from "../paginas/empleados/productos/buscar/HomeBuscarProductos";
import EditarProducto from '../paginas/empleados/productos/editar/EditarProductos';
import HomeEditarProductos from "../paginas/empleados/productos/editar/HomeEditarProductos";
import HomeProductos from "../paginas/empleados/productos/HomeProductos";
import NuevoProducto from "../paginas/empleados/productos/NuevoProducto";
import HomeTiposProductos from "../paginas/empleados/productos/tipos/HomeTipoProducto";
import HomeBuscarPromocion from '../paginas/empleados/promociones/buscar/HomeBuscarPromocion';
import EditarPromocion from '../paginas/empleados/promociones/editar/EditarPromocion';
import HomeEditarPromocion from '../paginas/empleados/promociones/editar/HomePromocion';
import HomePromocion from '../paginas/empleados/promociones/HomePromocion';
import HomeBuscarProveedor from '../paginas/empleados/proveedores/buscar/HomeBuscarProveedor';
import HomeEditarProveedor from '../paginas/empleados/proveedores/editar/HomeEditarProveedor';
import HomeProveedor from '../paginas/empleados/proveedores/HomeProveedor';
import HomeAnalisisVentas from '../paginas/empleados/ventas/analisis/HomeAnalisisVentas';
import HomeEditarVentas from '../paginas/empleados/ventas/anular/HomeEditarVenta';
import HomeCreditoVenta from '../paginas/empleados/ventas/credito/HomeCredito';
import HomeVentas from '../paginas/empleados/ventas/HomeVentas';
import ActualizarContrasena from "../paginas/login/ActualizarContraseña";
import EnviarPin from "../paginas/login/EnviarPin";
import Login from "../paginas/login/Login";
import ModalRegistroCliente from "../paginas/login/ModalRegistroCliente";
import { AdminLayout } from "./AdminLayout";
import { AutenticacionRoute } from "./AutenticacionRoute";
import { ClienteLayout } from "./ClienteLayout";
import AnalisisPage from '../paginas/empleados/analisis/AnalsisPage';
import VentasAnalisis from '../paginas/empleados/analisis/VentasAnalisis';
import ClientesAnalisis from '../paginas/empleados/analisis/ClientesAnalisis';
import ComprasAnalisis from '../paginas/empleados/analisis/ComprasAnalisis';
import InventariosAnalisis from '../paginas/empleados/analisis/InventariosAnalisis';
import ProductosAnalisis from '../paginas/empleados/analisis/ProductosAnalisis';
import EmpleadosAnalisis from '../paginas/empleados/analisis/EmpleadosAnalisis';
import CajasAnalisis from '../paginas/empleados/analisis/CajasAnalisis';
import { PedidoLayout } from './PedidoLayout';
import HomeVerVentas from '../paginas/empleados/ventas/anular/HomeVerVenta';

// Módulo de Planilla y Nómina
import HomePlanillas from '../paginas/empleados/planillas/HomePlanillas';
import GenerarPlanilla from '../paginas/empleados/planillas/GenerarPlanilla';
import DetallePlanilla from '../paginas/empleados/planillas/DetallePlanilla';
import ConfiguracionLaboral from '../paginas/empleados/planillas/ConfiguracionLaboral';
import GestionPrestamos from '../paginas/empleados/planillas/GestionPrestamos';

export const routes = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/login" element={<Login />} />
      <Route path="/recuperar-pin" element={<EnviarPin />} />
      <Route path="/actualizar-contrasena" element={<ActualizarContrasena />} />
      <Route path="/registro-cliente" element={<ModalRegistroCliente />} />
      <Route path="app/" element={<AutenticacionRoute />}>

        <Route path="clientes" element={<ClienteLayout />}>
          <Route path="" element={<InicioCliente />} />
          <Route path="pedidos/nuevo" element={<HomePedidos />} />
          <Route path="pedidos/editar" element={<EditarPedidos />} />
          <Route path="perfil" element={<HomeClientes />} />
          <Route path="productos" element={<ProductosCatalogo />} />
          <Route path="producto/:id" element={<ProductoDetalle />} />
          <Route path="cotizaciones/nuevo" element={<HomeCotizaciones />} />
          <Route path="cotizaciones/editar" element={<EditarCotizacion />} />
        </Route>

        <Route path="admin" element={<AdminLayout />}>
          <Route path="perfil" element={<HomeEmpleados />} />

          <Route path="analisis" element={<AnalisisPage />}>
            <Route path="ventas" element={<VentasAnalisis />} />
            <Route path="clientes" element={<ClientesAnalisis />} />
            <Route path="compras" element={<ComprasAnalisis />} />
            <Route path="inventarios" element={<InventariosAnalisis />} />
            <Route path="productos" element={<ProductosAnalisis />} />
            <Route path="empleados" element={<EmpleadosAnalisis />} />
            <Route path="cajas" element={<CajasAnalisis />} />
          </Route>

          <Route path="planillas">
            <Route index element={<HomePlanillas />} />
            <Route path="generar" element={<GenerarPlanilla />} />
            <Route path="detalle/:id" element={<DetallePlanilla />} />
            <Route path="configuracion" element={<ConfiguracionLaboral />} />
            <Route path="prestamos" element={<GestionPrestamos />} />
          </Route>

          <Route path="empleados" >
            <Route path="" element={<InicioEmpleados />} />
            <Route path="gestionar" element={<EditarEmpleados />} />
            <Route path="buscar" element={<HomeBuscarEmpleados />} />
            <Route path="nuevo" element={<NuevoEmpleado />} />
            <Route path="cargos" element={<HomeCargos />} />
            <Route path="accesos" element={<HomeAccesos />} />
          </Route>

          <Route path="promociones" >
            <Route path="" element={<InicioEmpleados />} />
            <Route path="nuevo" element={<HomePromocion />} />
            <Route path="buscar" element={<HomeBuscarPromocion />} />
            <Route path="editar" element={<HomeEditarPromocion />} />
            <Route path="editar/:id" element={<EditarPromocion />} />
          </Route>

          <Route path="productos" >
            <Route path="" element={<HomeProductos />} />
            <Route path="nuevo" element={<NuevoProducto />} />
            <Route path="buscar" element={<HomeBuscarProductos />} />
            <Route path="gestionar" element={<HomeEditarProductos />} />
            <Route path="gestionar/:id" element={<EditarProducto />} />
            <Route path="tipos" element={<HomeTiposProductos />} />
          </Route>

          <Route path="lotes" >
            <Route path="" element={<InicioEmpleados />} />
            <Route path="gestionar" element={<HomeEditarLotes />} />
            <Route path="gestionar/:productId/:loteId" element={<EditarLotes />} />
            <Route path="asignar" element={<HomeSelectLotes />} />
            <Route path="asignar/:productId/:loteId" element={<EditSelectLote />} />
            <Route path="/app/admin/lotes/asignar/:productId/:loteId/:loteInventarioId" element={<EditSelectLote />} />
          </Route>

          <Route path="inventarios" >
            <Route path="" element={<InicioEmpleados />} />
            <Route path="nuevo" element={<HomeInventarios />} />
            <Route path="gestionar" element={<HomeAnularInventarios />} />
            <Route path="tipos" element={<HomeInventarioTipo />} />
          </Route>

          <Route path="clientes">
            <Route index element={<InicioEmpleados />} />
            <Route path="gestionar" element={<HomeClientesEmpleados />} />
            <Route path="buscar" element={<HomeBuscarClientes />} />
            <Route path="nuevo" element={<NuevoCliente />} />
            <Route path="auto" element={<NuevoClienteAuto />} />
          </Route>

          <Route path="compras" >
            <Route index element={<InicioEmpleados />} />
            <Route path="nuevo" element={<HomeCompras />} />
            <Route path="gestionar" element={<HomeEditarCompras />} />
            <Route path="credito" element={<HomeCreditoCompra />} />
          </Route>

          <Route path="proveedores">
            <Route index element={<InicioEmpleados />} />
            <Route path="nuevo" element={<HomeProveedor />} />
            <Route path="buscar" element={<HomeBuscarProveedor />} />
            <Route path="gestionar" element={<HomeEditarProveedor />} />
          </Route>

          <Route path="pedidos" element={<PedidoLayout />}>
            <Route index element={<InicioEmpleados />} />
            <Route path="nuevo" element={<HomePedidosEmpleado />} />
            <Route path="buscar" element={<HomeBuscarPedidos />} />
            <Route path="gestionar" element={<EditarPedidosEmpleado />} />
          </Route>

          <Route path="cotizaciones" >
            <Route index element={<InicioEmpleados />} />
            <Route path="nuevo" element={<HomeCotizacionesEmpleados />} />
            <Route path="gestionar" element={<EditarCotizacionEmpleado />} />
          </Route>

          <Route path="ventas" >
            <Route index element={<InicioEmpleados />} />
            <Route path="nuevo" element={<HomeVentas />} />
            <Route path="gestionar" element={<HomeEditarVentas />} />
            <Route path="ver" element={<HomeVerVentas />} />
            <Route path="credito" element={<HomeCreditoVenta />} />
            <Route path="analisis" element={<HomeAnalisisVentas />} />
          </Route>

          <Route path="cajeros">
            <Route index element={<InicioEmpleados />} />
            <Route path="apertura" element={<HomeApertura />} />
            <Route path="cierre" element={<HomeCierre />} />
            <Route path="buscarCierre" element={<HomeBuscarCierre />} />
            <Route path="buscarApertura" element={<HomeBuscarApertura />} />
            <Route path="ingresosEgresos" element={<HomeIngresoEgreso />} />
            <Route path="buscarpagos" element={<HomePagos />} />
          </Route>

        </Route>
        <Route path="home" element={<PageHome />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" />} />
    </Route>
  ),
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);
